export default __webpack_public_path__ + "static/media/Francesca 9781846168895.569cca63.jpg";